import { Fragment } from "react";
import YudlButton from "../../components/Button";
import { ROUTES } from "../../constants";
import SectionItem from "./SectionItem";
import "./style.css";

const AboutUs = () => {
  return (
    <Fragment>
      <section className="about-show-case">
        <div className="about-show-case-content">
          <h1 className="display-4 text-theme text-center">“ if it was easy, then it’s a child’s game ”</h1>
          <blockquote className="text-theme text-end me-2">- African proverb</blockquote>
        </div>
      </section>
      <SectionItem
        direction="left-right"
        header="Our Mission"
        image="/assets/about/mission.png"
        children={
          <div>
            <p>
              We may not be building the next space rocket to take humans to mars, but we know someone out there is
              doing this. Thus our mission is simple -<br />
              <i className="fw-bold">
                “ to help our portfolio businesses identify their user needs and design customer friendly products
                quickly. ”
              </i>
            </p>
          </div>
        }
      />
      <SectionItem
        direction="right-left"
        header="Our Vision"
        image="/assets/about/vision.png"
        children={
          <div>
            <p>
              We’ve seen ideas die because there is no easy way to test customer demands quickly before developing the
              app/website. Some create crude products as “MVP” only for customers to walk away after a few tries due to
              poor user experience.
            </p>
            <p className="fw-bold">BUT.....WHAT IF</p>
            <p>
              What if a user can see the product MVP and interact with it before being developed -{" "}
              <strong>that is Our Vision</strong>
            </p>
          </div>
        }
      />
      <SectionItem
        direction="left-right"
        header="The Big Dream"
        image="/assets/about/big-dream.png"
        children={
          <div>
            <p>
              We want to provide businesses a platform where they can design new ideas, test them, learn from failures,
              identify new opportunities and build <strong>truely customer centric</strong> products that puts a smile
              on the faces of their users and the business.
            </p>
            <p>All these achieved with Design</p>
            <div className="d-flex my-4">
              <YudlButton buttonRole="link" children="Get Started" link={ROUTES.GETTING_STARTED} />
              <YudlButton
                className="ms-2"
                variant="outline-primary"
                buttonRole="link"
                children="View Portfolio"
                link={ROUTES.PORTFOLIO}
              />
            </div>
          </div>
        }
      />
    </Fragment>
  );
};

export default AboutUs;
